import React from "react";
import Slider from "react-slick";
import { SubHeading } from "./subHeading";
import { SimpleImg } from 'react-simple-img';
import Banners from "../data/data.json";


var settings = {
  dots: false,
  arrows: false,
  swipeToSlide: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  variableWidth: true
};

export const CategorySliders = props => {
  const cats = Banners.products.filter(item => item.categ === "cat");
  return (
    <>
      <SubHeading title={props.cat} />
      <div className="h-slider h-slider--cat">
        <Slider {...settings}>
          {cats.map(banners => {
            return (
              <div key={banners.id} className="img-wrap">
                <SimpleImg height={200} src={banners.img} alt={ banners.alt } placeholder="#f2f2f2" />
                <div className="cat-heading">{banners.alt}</div>
              </div>
            );
          })}
        </Slider>
      </div>
    </>
  );
};
